import React from 'react';
import PostSelectionItems from '@src/components/items-to-return/PostSelectionItems';
import { getItemsByShipment } from '@src/utils';
import { useSummaryStore } from '@src/stores/summaryStore';
var MultiAddressItems = function (_a) {
    var shipment = _a.shipment;
    var selectedReturnItems = useSummaryStore(function (state) { return state.selectedReturnItems; });
    var items = getItemsByShipment(shipment, selectedReturnItems);
    return (React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-mb-4 sui-mt-4", "data-testid": "multi-address-items" },
        React.createElement(PostSelectionItems, { selectedReturnItems: items })));
};
export default MultiAddressItems;
